//获取订单状态数量
export const getOrderStatusNum = (config = {}) => uni.$http.get('/api/mailing/v6/order/orderStatusNum', config)
//支付订单
export const postPayOrder = (config = {}) => uni.$http.post('/api/mailing/v7/shop/payOrder', config)
export const getPayOrder = (config = {}) => uni.$http.get('/api/mailing/v7/shop/payOrder', config)
//创建寄信订单
export const postCreateLetterOrder = (config = {}) => uni.$http.post('/api/mailing/v7/shop/createLetterOrder', config)
export const postPayLetterOrder = (config = {}) => uni.$http.post('/api/mailing/v7/shop/payLetterOrder', config)
//获取充值
export const getRecharge = (config = {}) => uni.$http.get('/api/mailing/v7/shop/recharge',
	config)
export const postRecharge = (config = {}) => uni.$http.post('/api/mailing/v7/shop/recharge', config)


//获取配置
export const getConfig = (config = {}) => uni.$http.get('/api/mailing/v5/app/config', config)
export const getLetterConfig = (config = {}) => uni.$http.get('/api/mailing/v5/app/letterConfig', config)

//获取首页
export const getHome = (config = {}) => uni.$http.get('/api/mailing/v5/app/home', config)

//我的
export const getUserInfo = (config = {}) => uni.$http.get('/api/mailing/v5/my/userInfo', config)
export const getMy = (config = {}) => uni.$http.get('/api/mailing/v5/my/my', config)
export const postMy = (config = {}) => uni.$http.post('/api/mailing/v5/my/my', config)

//顺手买更划算
export const getAddOnList = (config = {}) => uni.$http.get('/api/mailing/v7/shop/addOnList', config)

//商品
export const getMailLetterGoods = (config = {}) => uni.$http.get('/api/mailing/v5/app/mailLetterGoods',
	config)
//地址	
export const getAddress = (config = {}) => uni.$http.get('/api/mailing/v5/address/list',
	config)
export const postAddress = (config = {}) => uni.$http.post('/api/mailing/v5/address/edit', config)
//地址解析
export const getAddressParse = (config = {}) => uni.$http.get('/api/mailing/v5/address/parse', config)
//收货地址（旧版）
export const getAddressPast = (config = {}) => uni.$http.get('/api/mailing/v5/address/addressPast', config)
export const postAddressPastEdit = (config = {}) => uni.$http.post('/api/mailing/v5/address/addressPastEdit', config)

//获取我的订单分类
export const getOrderCategory = (config = {}) => uni.$http.get('/api/mailing/v6/order/category',
	config)


//获取模板分类
export const getTemplateCategory = (config = {}) => uni.$http.get('/api/mailing/v5/app/templateCategory',
	config)
//获取模板列表			
export const getTemplateList = (config = {}) => uni.$http.get('/api/mailing/v5/app/templateList',
	config)
//获取编辑配置
export const getEditLetter = (config = {}) => uni.$http.get('/api/mailing/v5/app/editLetter',
	config)


//获取信封规格
export const getLetterSpecs = (config = {}) => uni.$http.get('/api/mailing/v5/app/specs',
	config)

//获取人工传话
export const getPassMessage = (config = {}) => uni.$http.get('/api/mailing/v5/app/passMessage', config)
export const postCreatePassMessageOrder = (config = {}) => uni.$http.post('/api/mailing/v5/app/createPassMessageOrder',
	config)


//订单
export const getOrderRecord = (config = {}) => uni.$http.get('/api/mailing/v6/order/record', config)
export const postOrderRecord = (config = {}) => uni.$http.post('/api/mailing/v6/order/record', config)
export const postOrderPay = (config = {}) => uni.$http.post('/api/mailing/v6/order/pay', config)
export const getGoodsOrder = (config = {}) => uni.$http.get('/api/mailing/v6/order/goodsOrder',
	config)
export const postOrderComment = (config = {}) => uni.$http.post('/api/mailing/v6/order/comment', config)
//回信查询
export const getStampRecord = (config = {}) => uni.$http.get('/api/mailing/v6/stamp/list', config)
export const getStampDetail = (config = {}) => uni.$http.get('/api/mailing/v6/stamp/detail', config)
export const getStampSendConfig = (config = {}) => uni.$http.get('/api/mailing/v6/stamp/sendConfig', config)
export const postTransferToReady = (config = {}) => uni.$http.post('/api/mailing/v6/stamp/transferToReady', config)
export const postDestroyStamp = (config = {}) => uni.$http.post('/api/mailing/v6/stamp/destroy', config)
export const postStampSend = (config = {}) => uni.$http.post('/api/mailing/v6/stamp/send', config)
export const postStampBatchSend = (config = {}) => uni.$http.post('/api/mailing/v6/stamp/batchSend', config)
export const postStampLookTime = (config = {}) => uni.$http.post('/api/mailing/v6/stamp/lookTime', config)

//查看物流（统一入口，支持 type: mail_letter_v2/stamp/stamp_send）
export const getLogistics = (config = {}) => uni.$http.get('/api/mailing/v6/logistics/query', config)

//短信聊天
export const getMessageList = (config = {}) => uni.$http.get('/api/v1/chat_message/list', config)
export const postMessageList = (config = {}) => uni.$http.post('/api/v1/chat_message/list', config)

export const getChatMessageConfig = (config = {}) => uni.$http.get('/api/v1/chat_message/config', config)
export const getChatRecord = (config = {}) => uni.$http.get('/api/v1/chat_message/record', config)
export const postChatRecord = (config = {}) => uni.$http.post('/api/v1/chat_message/record', config)


//App审核领取余额
export const postReceiveBalance = (config = {}) => uni.$http.post('/api/v2/home/receiveBalance', config)


//通讯录
export const getContacts = (config = {}) => uni.$http.get('/api/mailing/v5/my/contacts', config)
export const postContacts = (config = {}) => uni.$http.post('/api/mailing/v5/my/contacts', config)


// 登录
export const postSendSmsCode = (config = {}) => uni.$http.post('/api/mailing/v5/login/send', config)
export const postSmsCodeLogin = (config = {}) => uni.$http.post('/api/mailing/v5/login/check', config)
export const postLoginThirdParty = (config = {}) => uni.$http.post('/api/mailing/v5/login/thirdParty', config)
export const getLoginThirdParty = (config = {}) => uni.$http.get('/api/mailing/v5/login/thirdParty', config)


//黑名单手机号
export const postBlockPhone = (config = {}) => uni.$http.post('/api/mailing/v5/app/blockPhone', config)
//绑定手机号
export const postBindPhone = (config = {}) => uni.$http.post('/api/mailing/v5/my/bindPhone', config)
//小程序自带的绑定手机号
export const postAuthBindPhone = (config = {}) => uni.$http.post('/api/mailing/v5/login/authBindPhone', config)


export const postPayNotify = (url, config = {}) => uni.$http.post(url, config)


//检测文本合规性
export const postCheckContent = (config = {}) => uni.$http.post('/api/mailing/v5/tool/checkTextContent', config)


//获取倒计时
export const getCountdown = (config = {}) => uni.$http.get('/api/mailing/v5/tool/countdown', config)
export const postCountdown = (config = {}) => uni.$http.post('/api/mailing/v5/tool/countdown', config)
//倒数事件 (v6)
export const getCountdownEventConfig = (config = {}) => uni.$http.get('/api/mailing/v6/countdown_event/config', config)
export const getCountdownEventList = (config = {}) => uni.$http.get('/api/mailing/v6/countdown_event/list', config)
export const getCountdownEventDetail = (config = {}) => uni.$http.get('/api/mailing/v6/countdown_event/detail', config)
export const postCountdownEvent = (config = {}) => uni.$http.post('/api/mailing/v6/countdown_event/edit', config)
export const postCountdownEventDelete = (config = {}) => uni.$http.post('/api/mailing/v6/countdown_event/delete', config)
//倒数事件分享海报
export const getCountdownSharePoster = (config = {}) => uni.$http.get('/api/mailing/v6/countdown_event/sharePoster', config)
//日记存稿
export const getDiary = (config = {}) => uni.$http.get('/api/mailing/v5/tool/diary', config)
export const postDiary = (config = {}) => uni.$http.post('/api/mailing/v5/tool/diary', config)


//App推送消息设置
export const postAppPush = (config = {}) => uni.$http.post('/api/mailing/v5/app/app_push', config)


//获取优惠券
export const getCouponList = (config = {}) => uni.$http.get('/api/mailing/v5/coupon/list', config)
//获取领券中心
export const getCouponOpenList = (config = {}) => uni.$http.get('/api/mailing/v5/coupon/open_list', config)
//获取首页发放券
export const getDistributeCoupons = (config = {}) => uni.$http.get('/api/mailing/v5/coupon/distributeCoupons', config)
//领取首页发放券
export const postDistributeCoupons = (config = {}) => uni.$http.post('/api/mailing/v5/coupon/distributeCoupons', config)

//获取关注二维码
export const getFollowQrcode = (config = {}) => uni.$http.get('/api/mailing/v5/coupon/followQrcode', config)


//获取首页问卷调查
export const getQuestionnaire = (config = {}) => uni.$http.get('/api/mailing/v5/coupon/questionnaire', config)
export const postQuestionnaire = (config = {}) => uni.$http.post('/api/mailing/v5/coupon/questionnaire', config)

//获取累计订单
export const getAccumulatedOrders = (config = {}) => uni.$http.get('/api/mailing/v5/coupon/accumulatedOrders', config)
export const postAccumulatedOrders = (config = {}) => uni.$http.post('/api/mailing/v5/coupon/accumulatedOrders', config)

//获取邀请海报
export const getSharePosters = (config = {}) => uni.$http.get('/api/mailing/v5/invite/sharePosters', config)
export const postSharePosters = (config = {}) => uni.$http.post('/api/mailing/v5/invite/sharePosters', config)
//获取邀请界面配置信息
export const getInviteConfig = (config = {}) => uni.$http.get('/api/mailing/v5/invite/config', config)

//AI
export const getAiConfig = (config = {}) => uni.$http.get('/api/mailing/v5/ai/config', config)
export const postAiConfig = (config = {}) => uni.$http.post('/api/mailing/v5/ai/config', config)
export const postAiChat = (config = {}) => uni.$http.post('/api/mailing/v5/ai/chat', config)

export const postLetterAnalyze = (config = {}) => uni.$http.post('/api/mailing/v5/ai/letterAnalyze', config)
export const postLetterAnalyzeRewrite = (config = {}) => uni.$http.post('/api/mailing/v5/ai/letterAnalyzeRewrite',
	config)



//个人隐私信息
export const getPermissionUserList = (config = {}) => uni.$http.get('/api/mailing/v5/permission/userList', config)
export const getPermissionUserListData = (config = {}) => uni.$http.get('/api/mailing/v5/permission/userListData',
	config)



//任务中心 签到
export const getMyTasks = (config = {}) => uni.$http.get('/api/mailing/v5/my/tasks', config)
export const postMyTasks = (config = {}) => uni.$http.post('/api/mailing/v5/my/tasks', config)
export const postMySign = (config = {}) => uni.$http.post('/api/mailing/v5/my/sign', config)
export const postMyExchange = (config = {}) => uni.$http.post('/api/mailing/v5/my/exchange', config)


//服刑预测
export const getForecastChargeMenu = (config = {}) => uni.$http.get('/api/mailing/v5/Forecast/chargeMenu', config)
export const getCrimeTree = (config = {}) => uni.$http.get('/api/mailing/v5/Forecast/getCrimeTree', config)
export const getCrimeRegionTree = (config = {}) => uni.$http.get('/api/mailing/v5/Forecast/getCrimeRegionTree', config)
export const getCrimeConfig = (config = {}) => uni.$http.get('/api/mailing/v5/Forecast/getCrimeConfig', config)
//创建订单
export const postCreateOrder = (config = {}) => uni.$http.post('/api/mailing/v5/Forecast/createOrder', config)
export const getOrderInfo = (config = {}) => uni.$http.get('/api/mailing/v5/Forecast/orderInfo', config)
export const getCrimeOrderRecord = (config = {}) => uni.$http.get('/api/mailing/v5/Forecast/orderRecord', config)
export const postCrimeOrderRecord = (config = {}) => uni.$http.post('/api/mailing/v5/Forecast/orderRecord', config)
export const getPrisonAddress = (config = {}) => uni.$http.get('/api/mailing/v5/Forecast/prisonAddress ', config)
export const postPrisonAddress = (config = {}) => uni.$http.post('/api/mailing/v5/Forecast/prisonAddress', config)
export const getSubTemplateIds = (config = {}) => uni.$http.get('/api/mailing/v5/Forecast/getSubTemplateIds', config)



//首页选项 物流查询
export const getHomeLetterLogistics = (config = {}) => uni.$http.get('/api/mailing/v5/tool/getHomeLetterLogistics',
	config)
export const getHomeLetterReplyLogistics = (config = {}) => uni.$http.get(
	'/api/mailing/v5/tool/getHomeLetterReplyLogistics', config)

//画板贴纸
export const getDiyTemplateList = (config = {}) => uni.$http.get('/api/mailing/v6/template/templateList',
	config)
export const getTemplateStickerCategory = (config = {}) => uni.$http.get('/api/mailing/v6/template/stickerCategory',
	config)
export const getTemplateStickerList = (config = {}) => uni.$http.get('/api/mailing/v6/template/stickerList',
	config)
export const postDiyUpdateConfig = (config = {}) => uni.$http.post('/api/mailing/v6/template/updateConfig', config)

export const getDiyUserTemplateList = (config = {}) => uni.$http.get('/api/mailing/v6/template/userTemplateList',
	config)
export const postDiyUserTemplateUpdate = (config = {}) => uni.$http.post('/api/mailing/v6/template/userTemplateUpdate',
	config)

//包月寄信
export const getMonthlyLetterConfig = (config = {}) => uni.$http.get('/api/mailing/v7/monthly_letter/config', config)
export const postCreateMonthlyOrder = (config = {}) => uni.$http.post('/api/mailing/v7/monthly_letter/createOrder', config)
export const postPayMonthlyOrder = (config = {}) => uni.$http.post('/api/mailing/v7/monthly_letter/payOrder', config)
export const getMonthlyLetterRecord = (config = {}) => uni.$http.get('/api/mailing/v7/monthly_letter/record', config)
export const getMonthlyLetterDetail = (config = {}) => uni.$http.get('/api/mailing/v7/monthly_letter/detail', config)
export const postMonthlyLetterContent = (config = {}) => uni.$http.post('/api/mailing/v7/monthly_letter/setContent', config)
export const postConfirmMonthlyContent = (config = {}) => uni.$http.post('/api/mailing/v7/monthly_letter/confirmContent', config)
export const getMonthlyLetterTemplates = (config = {}) => uni.$http.get('/api/mailing/v7/monthly_letter/templates', config)


// #ifdef H5
//后台管理
export const getAdminGoodsOrder = (config = {}) => uni.$http.get('/api/mailing/v5/admin/order/goodsOrder',
	config)
export const getAdminEditLetter = (config = {}) => uni.$http.get('/api/mailing/v5/admin/app/editLetter',
	config)
export const postAdminEditLetter = (config = {}) => uni.$http.post('/api/mailing/v5/admin/app/editLetter', config)
export const getAdminChatMessageConfig = (config = {}) => uni.$http.get('/api/mailing/v5/admin/chat_message/config',
	config)
export const getAdminChatRecord = (config = {}) => uni.$http.get('/api/mailing/v5/admin/chat_message/record', config)
export const postAdminChatRecord = (config = {}) => uni.$http.post('/api/mailing/v5/admin/chat_message/record', config)

export const getLyric = (config = {}) => uni.$http.get('/api/common/tool/lyric', config)
// #endif